// Global Types
import type {
  $Translate,
} from 'common.language';
import type {
  $Model,
  $ModelUpsertParams,
} from 'common.data';

// Global Components
import * as React from 'react';
import {
  Col,
  Row,
} from 'reactstrap';
import {
  AvField,
} from 'availity-reactstrap-validation';
import {
  InputDoubleButton,
  InputFile,
} from '@vroskus/library-components';

// Helpers
import ErrorLog from '@vroskus/library-sentry/dist/browser';
import config from '../../../config';

// Types
type $Props = $Translate & {
  item: $Model<'Banner'> | $ModelUpsertParams<'Banner'>;
};

const BannerFieldsView = function ({
  item,
  t,
}: $Props) {
  return (
    <>
      <Row>
        <Col sm={4}>
          <InputDoubleButton
            className={'mb-3'}
            label={t('Visibility')}
            labelFalse={t('Hidden')}
            labelTrue={t('Visible')}
            name={'Public'}
            value={item.Public}
          />
        </Col>
        <Col
          sm={8}
          xs={12}
        >
          <AvField
            label={t('Title')}
            name={'Name'}
            required
            value={item.Name}
          />
        </Col>
      </Row>
      <Row>
        <Col>
          <InputFile
            accept={['image']}
            fileDirUrl={`${config.CDN_URL}/files`}
            label={`${t('Image')} LG 1360 x 240`}
            labelChangeFile={t('Change file')}
            labelError={t('Error')}
            labelFile={t('File')}
            name={'ImageLG'}
            onError={ErrorLog.exception}
            required
            uploadUrl={`${config.CDN_URL}/v1.0/upload/file`}
            value={item.ImageLG}
          />
        </Col>
      </Row>
      <Row>
        <Col>
          <InputFile
            accept={['image']}
            fileDirUrl={`${config.CDN_URL}/files`}
            label={`${t('Image')} MD 940 x 240`}
            labelChangeFile={t('Change file')}
            labelError={t('Error')}
            labelFile={t('File')}
            name={'ImageMD'}
            onError={ErrorLog.exception}
            required
            uploadUrl={`${config.CDN_URL}/v1.0/upload/file`}
            value={item.ImageMD}
          />
        </Col>
      </Row>
      <Row>
        <Col>
          <InputFile
            accept={['image']}
            fileDirUrl={`${config.CDN_URL}/files`}
            label={`${t('Image')} SM 720 x 240`}
            labelChangeFile={t('Change file')}
            labelError={t('Error')}
            labelFile={t('File')}
            name={'ImageSM'}
            onError={ErrorLog.exception}
            required
            uploadUrl={`${config.CDN_URL}/v1.0/upload/file`}
            value={item.ImageSM}
          />
        </Col>
      </Row>
      <Row>
        <Col>
          <InputFile
            accept={['image']}
            fileDirUrl={`${config.CDN_URL}/files`}
            label={`${t('Image')} XS 480 x 240`}
            labelChangeFile={t('Change file')}
            labelError={t('Error')}
            labelFile={t('File')}
            name={'ImageXS'}
            onError={ErrorLog.exception}
            required
            uploadUrl={`${config.CDN_URL}/v1.0/upload/file`}
            value={item.ImageXS}
          />
        </Col>
      </Row>
      <Row>
        <Col>
          <AvField
            label={t('Container classes')}
            name={'ContainerClass'}
            value={item.ContainerClass}
          />
        </Col>
      </Row>
      <Row>
        <Col sm={6}>
          <AvField
            label={t('Button name')}
            name={'ButtonName'}
            value={item.ButtonName}
          />
        </Col>
        <Col sm={6}>
          <AvField
            label={t('Button link')}
            name={'ButtonLink'}
            value={item.ButtonLink}
          />
        </Col>
      </Row>
      <Row>
        <Col>
          <AvField
            label={t('Button classes')}
            name={'ButtonClass'}
            value={item.ButtonClass}
          />
        </Col>
      </Row>
    </>
  );
};

export default BannerFieldsView;
